// export const BASE_URL = 'http://localhost:8000'
export const BASE_URL = 'https://marjolein-varekamp-backend.herokuapp.com'

// MAPBOX
export const MAP_URL = 'https://api.mapbox.com/styles/v1/jorisphilipsen/cj8w0u34zfqcx2ro3t1k8w8rt/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoiam9yaXNwaGlsaXBzZW4iLCJhIjoiY2luaWoxbmV6MDA0MXZza2wyMmM1azk5ZyJ9.nIlE7rUXmJLKvtEmSs45lw'

// Website head
export const WEBSITE_HEAD = 'Marjolein Varekamp -'

// Device width
export const MOBILEDEVICEWIDTH = 768
export const DESKTOPTABLETDEVICEWIDTH = 769


// WEBPACK FOOTER //
// ./src/utils/constants.js